import { ngxPermissionsGuard } from 'ngx-permissions';
import { LABELS, PERMISSIONS } from '@shared/constants';
import { ExtendedRoute } from '@shared/models';

const maintenanceRoutes: ExtendedRoute[] = [
	{
		path: 'payroll-calendar',
		loadComponent: () =>
			import('./generic-maintenance/components/payroll-schedule/calendar/payroll-calendar.component')
				.then(c => c.PayrollCalendarComponent),
		canActivate: [ngxPermissionsGuard],
		data: {
			label: LABELS.PAYROLL_SCHEDULE_CALENDAR,
			permissions: {
				only: [
					PERMISSIONS.VIEW_PHILHEALTH_LIST,
					PERMISSIONS.MANAGE_PHILHEALTH_LIST
				],
				redirectTo: 'no-permission'
			}
		}
	},
	{
		path: 'philhealth-configuration',
		loadComponent: () =>
			import('./generic-maintenance/components/philhealth/philhealth.component')
				.then(c => c.PhilhealthComponent),
		canActivate: [ngxPermissionsGuard],
		data: {
			label: LABELS.PHILHEALTH,
			permissions: {
				only: [
					PERMISSIONS.VIEW_PHILHEALTH_LIST,
					PERMISSIONS.MANAGE_PHILHEALTH_LIST
				],
				redirectTo: 'no-permission'
			}
		}
	},
	{
		path: 'deduction',
		loadComponent: () =>
			import('./generic-maintenance/components/deductions/deductions.component')
				.then(c => c.DeductionsComponent),
		canActivate: [ngxPermissionsGuard],
		data: {
			label: LABELS.DEDUCTION,
			permissions: {
				only: [
					PERMISSIONS.VIEW_PHILHEALTH_LIST,
					PERMISSIONS.MANAGE_PHILHEALTH_LIST
				],
				redirectTo: 'no-permission'
			}
		}
	},
	{
		path: 'overtime-rate',
		loadComponent: () =>
			import('./generic-maintenance/components/overtime-rate/overtime-rate.component')
				.then(c => c.OvertimeRateComponent),
		data: {
			label: LABELS.OVERTIME_RATE,
		}
	},
	{
		path: 'pagibig-configuration',
		loadComponent: () =>
			import('./generic-maintenance/components/pagibig/pagibig.component')
				.then(c => c.PagibigComponent),
		canActivate: [ngxPermissionsGuard],
		data: {
			label: LABELS.PAGIBIG,
			permissions: {
				only: [
					PERMISSIONS.VIEW_PAGIBIG_LIST,
					PERMISSIONS.MANAGE_PAGIBIG_LIST
				],
				redirectTo: 'no-permission'
			}
		}
	},
	{
		path: 'pagibig-salary-cap',
		loadComponent: () =>
			import('./generic-maintenance/components/pagibig-salary-cap/pagibig-salary-cap.component')
				.then(c => c.PagibigSalaryCapComponent),
		canActivate: [ngxPermissionsGuard],
		data: {
			label: LABELS.PAGIBIG_SALARY_CAP,
			permissions: {
				only: [
					PERMISSIONS.VIEW_PHILHEALTH_LIST,
					PERMISSIONS.MANAGE_PHILHEALTH_LIST
				],
				redirectTo: 'no-permission'
			}
		}
	},
	{
		path: 'benefit',
		loadComponent: () =>
			import('./generic-maintenance/components/benefit/benefit.component')
				.then(c => c.BenefitComponent),
		canActivate: [ngxPermissionsGuard],
		data: {
			label: LABELS.BENEFITS,
			permissions: {
				only: [
					PERMISSIONS.VIEW_BENEFIT_LIST,
					PERMISSIONS.MANAGE_BENEFIT_LIST
				],
				redirectTo: 'no-permission'
			}
		}
	},
	{
		path: 'night-diff',
		loadComponent: () =>
			import('./night-diff-configuration/night-diff-configuration.component')
				.then(c => c.NightDiffConfigurationComponent),
		canActivate: [ngxPermissionsGuard],
		data: {
			label: LABELS.NIGHT_DIFFERENTIAL,
			permissions: {
				only: [
					PERMISSIONS.VIEW_NIGHT_DIFF_LIST,
					PERMISSIONS.MANAGE_NIGHT_DIFF_LIST
				],
				redirectTo: 'no-permission'
			}
		}
	},
	{
		path: 'holiday-pay-schedule',
		loadComponent: () =>
			import('./generic-maintenance/components/holiday-pay-schedule/holiday-pay-schedule.component')
				.then(c => c.HolidayPayScheduleComponent),
		canActivate: [ngxPermissionsGuard],
		data: {
			label: LABELS.HOLIDAY_PAY_SCHEDULE,
			permissions: {
				only: [
					// PERMISSIONS.VIEW_NIGHT_DIFF_LIST,
					// PERMISSIONS.MANAGE_NIGHT_DIFF_LIST
				],
				redirectTo: 'no-permission'
			}
		}
	},
	{
		path: 'ctpa',
		loadComponent: () =>
			import('./generic-maintenance/components/ctpa/ctpa.component')
				.then(c => c.CtpaComponent),
		canActivate: [ngxPermissionsGuard],
		data: {
			label: LABELS.CTPA,
			permissions: {
				only: [
					PERMISSIONS.VIEW_SSS_LIST,
					PERMISSIONS.MANAGE_SSS_LIST
				],
				redirectTo: 'no-permission'
			}
		}
	},
	{
		path: 'sss',
		loadComponent: () =>
			import('./generic-maintenance/components/sss/sss.component')
				.then(c => c.SssComponent),
		canActivate: [ngxPermissionsGuard],
		data: {
			label: LABELS.SSS_CONFIGURATION,
			permissions: {
				only: [
					PERMISSIONS.VIEW_SSS_LIST,
					PERMISSIONS.MANAGE_SSS_LIST
				],
				redirectTo: 'no-permission'
			}
		}
	},
	{
		path: 'gsis',
		loadComponent: () =>
			import('./gsis/gsis.component')
				.then(c => c.GsisComponent),
		canActivate: [ngxPermissionsGuard],
		data: {
			label: LABELS.GSIS_CONFIGURATION,
			permissions: {
				only: [
					PERMISSIONS.VIEW_GSIS_LIST,
					PERMISSIONS.MANAGE_GSIS_LIST
				],
				redirectTo: 'no-permission'
			}
		}
	},
	{
		path: 'annual-tax',
		loadChildren: () =>
			import('./annual-tax/annual-tax.routes'),
		canActivate: [ngxPermissionsGuard],
		data: {
			label: LABELS.ANNUAL_TAX,
			permissions: {
				only: [
					PERMISSIONS.VIEW_ANNUAL_TAX_LIST,
					PERMISSIONS.MANAGE_ANNUAL_TAX_LIST
				],
				redirectTo: 'no-permission'
			}
		}
	},
	{
		path: 'rest-day',
		loadComponent: () =>
			import('./generic-maintenance/components/rest-day/rest-day.component')
				.then(c => c.RestDayComponent),
		canActivate: [ngxPermissionsGuard],
		data: {
			label: LABELS.REST_DAY_RATE,
			permissions: {
				only: [
					PERMISSIONS.VIEW_REST_DAY_RATE_LIST,
					PERMISSIONS.MANAGE_REST_DAY_RATE_LIST
				],
				redirectTo: 'no-permission'
			}
		}
	},
	{
		path: 'allowance',
		loadComponent: () =>
			import('./generic-maintenance/components/allowance/allowance.component')
				.then(c => c.AllowanceComponent),
		canActivate: [ngxPermissionsGuard],
		data: {
			label: LABELS.ALLOWANCE,
			permissions: {
				only: [
					PERMISSIONS.VIEW_ALLOWANCE_LIST,
					PERMISSIONS.MANAGE_ALLOWANCE_LIST
				],
				redirectTo: 'no-permission'
			}
		}
	}
]

export default maintenanceRoutes;
